export const ID_SHOP_BELGIUM = 2;

export const isBelgiumShop = () => {
    return typeof window !== 'undefined' && window.id_shop === ID_SHOP_BELGIUM;
};
